/* eslint-disable react/no-array-index-key */
import React, { lazy, Suspense, Fragment } from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import DashboardLayout from "src/layouts/DashboardLayout";
import AdminDashboardLayout from "src/layouts/AdminDashboardLayout";
import UserDashboardLayout from "src/layouts/UserDashboardLayout";

import DocsLayout from "src/layouts/DocsLayout";
import MainLayout from "src/layouts/MainLayout";
import HomeView from "src/views/pages/HomeView";
import LoadingScreen from "src/components/LoadingScreen";
import AuthGuard from "src/components/AuthGuard";
import AdminAuthGuard from "src/components/AdminAuthGuard";

import GuestGuard from "src/components/GuestGuard";

const routesConfig = [
  {
    exact: true,
    path: "/",
    component: () => <Redirect to="/user" />
  },
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("src/views/pages/Error404View"))
  },
  {
    exact: true,
    path: "/login",
    component: lazy(() => import("src/views/auth/LoginView"))
  },
  {
    exact: true,
    path: "/register",
    component: lazy(() => import("src/views/auth/RegisterView"))
  },
  {
    path: "/admin",
    guard: AdminAuthGuard,
    layout: AdminDashboardLayout,
    routes: [
      {
        exact: true,
        path: "/admin",
        component: () => <Redirect to="/admin/customers" />
      },
      {
        exact: true,
        path: "/admin/customers",
        component: lazy(() => import("src/views/admin/CustomerListView"))
      },
      {
        exact: true,
        path: "/admin/account",
        component: lazy(() => import("src/views/admin/MyAccountView"))
      },
      {
        exact: true,
        path: "/admin/account/edit",
        component: lazy(() => import("src/views/admin/MyAccountEditView"))
      },

      {
        exact: true,
        path: "/admin/partners",
        component: lazy(() => import("src/views/admin/PartnerListView"))
      },
      {
        exact: true,
        path: "/admin/customers/:customerId",
        component: lazy(() => import("src/views/admin/CustomerDetailsView"))
      },
      {
        exact: true,
        path: "/admin/customers/:customerId/edit",
        component: lazy(() => import("src/views/admin/CustomerEditView"))
      },

      {
        exact: true,
        path: "/admin/CustomerCreateView",
        component: lazy(() => import("src/views/admin/CustomerCreateView"))
      },
      {
        exact: true,
        path: "/admin/EquipmentCreateView",
        component: lazy(() => import("src/views/admin/EquipmentCreateView"))
      },
      {
        exact: true,
        path: "/admin/ApplicationCreateView",
        component: lazy(() => import("src/views/admin/ApplicationCreateView"))
      },
      {
        exact: true,
        path: "/admin/applications",
        component: lazy(() => import("src/views/admin/ApplicationListView"))
      },
      {
        exact: true,
        path: "/admin/applications/:applicationId",
        component: lazy(() => import("src/views/admin/ApplicationDetailsView"))
      },
      {
        exact: true,
        path: "/admin/equipments/",
        component: lazy(() => import("src/views/admin/EquipmentListView"))
      },
      {
        exact: true,
        path: "/admin/reports/",
        component: lazy(() => import("src/views/admin/ReportListView"))
      },
      {
        exact: true,
        path: "/admin/reports/:reportsId",
        component: lazy(() => import("src/views/admin/ReportDetailsView"))
      },
      {
        exact: true,
        path: "/admin/equipments/:equipmentId",
        component: lazy(() => import("src/views/admin/EquipmentDetailsView"))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: "/user",
    guard: AuthGuard,
    layout: UserDashboardLayout,
    routes: [
      {
        exact: true,
        path: "/user",
        component: () => <Redirect to="/user/applications" />
      },
      {
        exact: true,
        path: "/user/account",
        component: lazy(() => import("src/views/user/MyAccountView"))
      },
      {
        exact: true,
        path: "/user/account/edit",
        component: lazy(() => import("src/views/user/MyAccountEditView"))
      },
      {
        exact: true,
        path: "/user/EquipmentCreateView",
        component: lazy(() => import("src/views/user/EquipmentCreateView"))
      },
      {
        exact: true,
        path: "/user/ApplicationCreateView",
        component: lazy(() => import("src/views/user/ApplicationCreateView"))
      },
      {
        exact: true,
        path: "/user/applications",
        component: lazy(() => import("src/views/user/ApplicationListView"))
      },
      {
        exact: true,
        path: "/user/applications/:applicationId",
        component: lazy(() => import("src/views/user/ApplicationDetailsView"))
      },
      {
        exact: true,
        path: "/user/equipments/",
        component: lazy(() => import("src/views/user/EquipmentListView"))
      },
      {
        exact: true,
        path: "/user/equipments/:equipmentId",
        component: lazy(() => import("src/views/user/EquipmentDetailsView"))
      },
      {
        exact: true,
        path: "/user/reports/",
        component: lazy(() => import("src/views/user/ReportListView"))
      },
      {
        exact: true,
        path: "/user/reports/:reportsId",
        component: lazy(() => import("src/views/user/ReportDetailsView"))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = routes =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={props => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
